import * as React from 'react';
import { Component } from 'react';
import ChevronDown from 'react-feather/dist/icons/chevron-down';
import styled from 'react-emotion';
import { MenuLink } from './MenuLink';
import { SubMenu } from './SubMenu';
import { get } from '@utils/theme';
const sidebarBg = get('colors.sidebarBg');
const Wrapper = styled('div') `
  background-color: ${sidebarBg};
  display: flex;
  flex-direction: column;
  margin-bottom: ${p => (p.level > 0 ? 0 : 36)}px;
`;
const iconRotate = (p) => (p.opened ? '-180deg' : '0deg');
const Icon = styled('div') `
  position: absolute;
  pointer-events: none;
  top: 50%;
  right: 20px;
  transform: translateY(-50%) rotate(${iconRotate});
  transform-origin: 50% 50%;
  transition: transform 0.3s;
  height: 1rem;
  width: 1rem;

  & svg {
    position: absolute;
    top: 0;
    left: 0;
    height: 1rem;
    width: 1rem;
    stroke: ${get('colors.sidebarText')};
    stroke-width: 2px;
  }
`;
export class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opened: false,
            hasActive: false,
            hovered: false,
            menuPosition: undefined,
        };
        this.toggle = () => {
            this.setState(state => ({ opened: !state.opened }));
        };
        this.checkActiveLink = () => {
            const { isDesktop } = this.props;
            const activeLink = this.menu && this.menu.querySelector('a.active');
            const hasActive = Boolean(activeLink);
            if (hasActive) {
                this.setState({ hasActive, opened: true });
                if (isDesktop) {
                    setTimeout(() => activeLink && activeLink.scrollIntoView());
                }
            }
        };
        this.menu = null;
        this.timer = null;
    }
    componentDidMount() {
        this.checkActiveLink();
    }
    render() {
        const { item, collapseAll, level } = this.props;
        const show = collapseAll || this.state.opened;
        const hasHeadings = Boolean(item.headings && item.headings.length > 0);
        const hasItems = Boolean(item.items && item.items.length > 0);
        const hasMenus = Boolean(item.menus && item.menus.length > 0);
        const hasChildren = hasItems || hasMenus;
        const hasToggle = hasChildren;
        const handleToggle = (ev) => {
            ev.preventDefault();
            this.toggle();
        };
        return (React.createElement(Wrapper, { hasMenus: hasMenus, opened: show, level: level, innerRef: (node) => {
                this.menu = node;
            } },
            React.createElement(MenuLink, Object.assign({ item: item }, hasToggle && { onClick: handleToggle }, { level: level }),
                item.name,
                (hasChildren || hasHeadings) && (React.createElement(Icon, { opened: show },
                    React.createElement(ChevronDown, { size: 15 })))),
            hasChildren && React.createElement(SubMenu, Object.assign({ show: show }, this.props))));
    }
}
//# sourceMappingURL=data:application/json;base64,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